import React from "react";
import { useTranslation } from "react-i18next";
import { History } from "components/History/History";
import { ExportToCsv } from "export-to-csv";
import { useMutation } from "@tanstack/react-query";
import { exportHistory } from "./HistoryPage.api";
import { useAuth } from "context/auth-context";
import { toast } from "react-toastify";
import { FiDownload } from "react-icons/fi";
import { Card, PageHeader } from "components/ui";
export const HistoryPage = () => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const mutation = useMutation(() => exportHistory(auth?.panelistId));
  

  const mutatefunction= ()=>{
    if (mutation?.status === "success" && mutation?.data?.success) {
      const responseData = mutation?.data?.data;
      if (Array.isArray(responseData) && responseData?.length > 0) {
        const options = {
          fieldSeparator: ",",
          quoteStrings: '"',
          decimalSeparator: ".",
          showLabels: true,
          showTitle: false,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          title: "Survey_History_Report",
          filename: "Survey_History_Report",
        };
        const csvExporter = new ExportToCsv(options);
        const csvData = responseData.map((e) => ({
          surveyName: e.surveyName,
          points: e.points,
          createdAt: e.createdAt,
          status:
            e.surveyStatus === 1 || e.surveyStatus === 2 || e.surveyStatus === 3
              ? e.surveyStatusName
              : !e.surveyStatus || e.surveyStatus === 0
              ? "Not Completed"
              : "Terminated",
        }));
        csvExporter.generateCsv(csvData);
      } else {
        toast.error(t("history.SurveyEmpty"));
      }
    }
  };
  const getExportData = () => {
    mutation.mutate();
    mutatefunction();
  };
  return (
    <div className="zs-page">
      <PageHeader
        eyebrow="Activity"
        title={t("histortpage.surveyHistory")}
        actions={
          <button data-testid="button" onClick={() => getExportData()} className="zs-btn zs-btn-secondary">
            <FiDownload />
            {t("history.Exporter")}
          </button>
        }
      />
      <Card flush>
        <div data-testid="survey" className="w-full">
          <History />
        </div>
      </Card>
    </div>
  );
};
